/**
 * Stable CSS class names for E2E — Greeting notes.
 */
export const GREETING = {
    page: 'greeting-notes-page',
    mainGrid: 'greeting-notes-page__main-grid',
    headerSection: 'greeting-notes-page__header-section',
    actionsToolbar: 'greeting-notes-page__actions-toolbar',
    inputButtonAdd: 'greeting-notes-page-input--button-add',
    gridWrap: 'greeting-notes-page__grid-wrap',
    datagridCellTitle: 'greeting-notes-page-datagrid-cell--title',
    inputSwitchRowActive: 'greeting-notes-page-input--switch-row-active',
    inputButtonRowEdit: 'greeting-notes-page-input--button-row-edit',

    drawerRoot: 'greeting-notes-drawer',
    drawerHeaderRow: 'greeting-notes-drawer__header-row',
    drawerTitle: 'greeting-notes-drawer__title',
    inputIconDrawerClose: 'greeting-notes-drawer-input--icon-close',
    drawerForm: 'greeting-notes-drawer__form',
    inputTextTitle: 'greeting-notes-drawer-input--text-title',
    inputTextContent: 'greeting-notes-drawer-input--text-content',
    activeSwitchRow: 'greeting-notes-drawer__active-switch-row',
    inputSwitchActive: 'greeting-notes-drawer-input--switch-active',
    drawerFooterActions: 'greeting-notes-drawer__footer-actions',
    inputButtonUpdate: 'greeting-notes-drawer-input--button-update',
    inputButtonSave: 'greeting-notes-drawer-input--button-save',
} as const;

export const greetingCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
